import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SystemErrorAlert } from "Components/Form/Alert/SystemErrorAlert";
import { pageDisplayed } from "Store/analytics/analyticsSlice";
import { ReduxState } from "Store/rootReducer";
import { AppPartName } from "Utils/analytics";
import { ProductBackendName } from "../../Products/productTypes";
import { Illustration } from "./components/Illustration";
import { ProductLoginSwitch } from "./components/ProductLoginSwitch";

interface LoginTileProps {
  readonly productBackendName: ProductBackendName;
}

export const LoginTile = ({
  productBackendName,
}: LoginTileProps): React.ReactElement => {
  const dispatch = useDispatch();

  const userIdentificationError = useSelector(
    (state: ReduxState) => state.userIdentification.error,
  );

  useEffect(() => {
    dispatch(pageDisplayed({ pageName: AppPartName.PRODUCT_REDIRECT }));
    dispatch(pageDisplayed({ pageName: AppPartName.LOGIN }));
  }, []);

  return (
    <>
      <Illustration productBackendName={productBackendName} />
      {userIdentificationError && (
        <SystemErrorAlert alertId="userIdentification-login" marginTop="32px" />
      )}
      <ProductLoginSwitch productBackendName={productBackendName} />
    </>
  );
};
